// @flow

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router-dom'
import includes from 'lodash/includes'

import type { User } from '../../types'

type Props = {
  component: any,
  allow: string | Array<string>,
  user: User
}

class PrivateRoute extends Component<Props> {
  render() {
    const { component: Component, allow, user, ...rest } = this.props

    return (
      <Route {...rest} render={(props) => (
        (() => {
          if (!user) {
            return <Redirect to='/login' />
          } else if (includes(allow, user.role)) {
            return <Component {...props} />
          } else {
            return <Redirect to='/no-permission' />
          }
        })()
      )} />
    )
  }
}

const mapStateToProps = state => ({
  user: state.global.user
})

export default withRouter(connect(mapStateToProps)(PrivateRoute))



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute/index.js